import { createPopper } from "@popperjs/core";
import { devLog } from "../utils/_log";
import * as bootstrap from "bootstrap";
// Se usi Bootstrap via import, opzionalmente puoi scommentare la riga sotto
// import Collapse from "bootstrap/js/dist/collapse";

class General {
  constructor() {
    this.popper();
    this.iframe();
    this.seeMoreCollapse(); // inizializza la logica "Vedi di più"
    this.initTooltips(); // inizializza tooltips boostrap
  }

  popper() {
    try {
      // Nota: referenceElement, popperElement e placement devono esistere nel contesto
      const dropdown = createPopper(referenceElement, popperElement, {
        placement: placement || "bottom", // Fallback per placement
      });
    } catch (error) {
      devLog("Errore nella creazione del Popper");
    }
  }

  iframe() {
    const frame = document.getElementById("Iframe");

    if (frame) {
      console.log(frame);

      const adjustIframe = () => {
        try {
          // Controlla se l'iframe è accessibile (stesso dominio o CORS permessi)
          const doc = frame.contentWindow.document;
          frame.style.height = doc.documentElement.scrollHeight + "px";
          frame.style.width = doc.documentElement.scrollWidth + "px";
          console.log("iframe adjusted");
        } catch (e) {
          console.error("Cross-origin issue or iframe not ready", e);
        }
      };

      frame.addEventListener("load", adjustIframe);

      // Polling per verificare quando l'iframe è pronto
      const interval = setInterval(() => {
        if (
          frame.contentWindow &&
          frame.contentWindow.document.readyState === "complete"
        ) {
          clearInterval(interval);
          adjustIframe();
        }
      }, 100);
    }
  }

  // Gestisce i pulsanti "Vedi di più / Vedi meno" per i contenuti Bootstrap Collapse.
  seeMoreCollapse() {
    try {
      // Seleziona tutti i bottoni che devono gestire l'etichetta dinamica
      // data-see-more-toggle: attiva questo script sul bottone
      const toggleButtons = document.querySelectorAll(
        '[data-bs-toggle="collapse"][data-see-more-toggle]'
      );

      if (!toggleButtons.length) return;

      toggleButtons.forEach((btn) => {
        // Ricava il selettore target (supporta sia data-bs-target che href come fallback)
        const targetSelector =
          btn.getAttribute("data-bs-target") || btn.getAttribute("href");
        if (!targetSelector) return;

        const collapseEl = document.querySelector(targetSelector);
        if (!collapseEl) return;

        // Etichette personalizzabili con fallback
        const showLabel = btn.getAttribute("data-show-label") || "Vedi di più";
        const hideLabel = btn.getAttribute("data-hide-label") || "Vedi meno";

        // Funzione di utilità per aggiornare lo stato del bottone
        const updateButtonLabel = () => {
          // Bootstrap aggiunge/rimuove la classe 'show' sull'elemento collapse
          const isOpen = collapseEl.classList.contains("show");
          btn.textContent = isOpen ? hideLabel : showLabel;
          btn.setAttribute("aria-expanded", String(isOpen));
        };

        // Inizializzazione stato etichetta al load
        updateButtonLabel();

        // Ascolta gli eventi di Bootstrap per sincronizzare l'etichetta
        // - 'shown.bs.collapse': quando l'elemento è completamente visibile
        // - 'hidden.bs.collapse': quando l'elemento è completamente nascosto
        collapseEl.addEventListener("shown.bs.collapse", updateButtonLabel);
        collapseEl.addEventListener("hidden.bs.collapse", updateButtonLabel);
      });
    } catch (error) {
      devLog("Errore nella gestione 'Vedi di più / Vedi meno'");
    }
  }

  // Inizializzo tooltips boostrap
  initTooltips() {
    try {
      const tooltipTriggerList = Array.from(
        document.querySelectorAll('[data-bs-toggle="tooltip"]')
      );

      tooltipTriggerList.forEach((tooltipTriggerEl) => {
        const placement =
          tooltipTriggerEl.getAttribute("data-bs-placement") || "top";

        new bootstrap.Tooltip(tooltipTriggerEl, {
          trigger: "click",
          placement: placement,
          delay: { show: 0, hide: 0 },
          animation: true,
        });
      });

      // Chiudi i tooltip quando si clicca fuori
      document.addEventListener("click", (e) => {
        if (!e.target.closest('[data-bs-toggle="tooltip"]')) {
          tooltipTriggerList.forEach((el) => {
            const tooltipInstance = bootstrap.Tooltip.getInstance(el);
            if (tooltipInstance) {
              tooltipInstance.hide();
            }
          });
        }
      });

      console.log(
        `${tooltipTriggerList.length} tooltip inizializzati con successo`
      );
    } catch (error) {
      console.error("Errore nell'inizializzazione dei tooltip:", error);
    }
  }
}

export default General;
